import * as React from 'react';
import { observer } from 'mobx-react';
import { inject } from '../../../../utils';
import { withTheme } from 'styled-components';
import ToasterWrapper from './StyledComponents/ToasterWrapper';
import ToastWrapper from './StyledComponents/ToastWrapper';
import Toast from '../Toast/';
import { ToasterProps, ToasterThemeKeys } from './Models';
import { ThemeableComponent } from '../../../../utils/theme/ThemeableComponent';

@inject('feedbackStore')
@observer
class Toaster extends ThemeableComponent<ToasterProps, {}, ToasterThemeKeys> {
    DEFAULT_THEME_KEYS: ToasterThemeKeys = {
        toasterWrapper: 'ToasterWrapper',
        toastWrapper: 'ToastWrapper',
    };

    constructor(props: ToasterProps) {
        super(props);
    }

    render() {
        const { feedbackStore } = this.props;
        const { toasterMessages } = feedbackStore;
        return (
            <ToasterWrapper {...this.getTheme('toasterWrapper')}>
                {toasterMessages.map(toastStore => {
                    const { key } = toastStore;
                    return (
                        <ToastWrapper
                            key={key}
                            {...this.getTheme('toastWrapper')}
                        >
                            <Toast toastStore={toastStore} />
                        </ToastWrapper>
                    );
                })}
            </ToasterWrapper>
        );
    }
}

export default withTheme(Toaster) as any;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Components/Toaster/Toaster.tsx